import React, {useEffect, useMemo, useRef, useState} from 'react';
import {
    Box,
    VStack,
    HStack,
    Flex,
    Text,
    useColorModeValue,
    Textarea,
    Button,
    ListItem,
    useDisclosure,
    useToast,
    ListIcon,
    List,
    Icon,
} from '@chakra-ui/react';
import {useDispatch, useSelector} from "react-redux";
import {useAuth} from "../../redux/AuthProvider";
import lightTheme from "../../utils/styles";
import {FaCheckCircle} from "react-icons/fa";
import {AiOutlineArrowRight, AiOutlineSend} from "react-icons/ai";
import {
    setCurrentChatInputGeneration,
    setCurrentGenerationWordCount,
    setIsPricingModalOpen,
    setIsUploadSourcesModalOpen,
    setIsGeneratePDFVisible,
    setCurrentGeneratePDF,
    setCurrentGeneratePDFPage,
    updateMessageInDocument,
    updateMessageInDocumentGeneration,
    addMessageInDocumentGeneration,
    resetCurrentChatResponseGeneration,
    setCurrentChatUserIDGeneration,
    setCurrentChatClaudeIDGeneration,
    setCurrentChatQuestionGeneration,
    setCurrentChatTypeGeneration,
    updateMessageInDocumentGeneration2
} from "../../redux/reducers";
import SignUpScreen1 from "../Modals/SignUp/SignUpScreen1";
import SignInScreen1 from "../Modals/SignIn/SignInScreen1";
import GeneratePromptScreen2 from "../Modals/Generation/GeneratePromptScreen2";
import PricingScreen from "../Modals/Payments/PricingScreen";
import {useTranslation} from "react-i18next";
import {MessageBubbleMultidoc} from "./MessageBubbleMultidoc";
import { AiOutlineUpload } from "react-icons/ai";
import axios from "axios";
import {useServerIP} from "../../redux/ServerIPContext";
import lottieFixOCR from './lottie-fix-ocr.json';
import Lottie from "lottie-react";
import { v4 as uuidv4 } from 'uuid';
import {MessageBubbleMultidoc2} from "./MessageBubbleMultidoc2";

export const Generation2 = ({ theDocumentGeneration, sessionTokenGeneration, socketIDGeneration, socketGeneration,
                               stopClaudeResponseGeneration, pdfRef }) => {
    const {t} = useTranslation();
    const lastMessageRef = useRef(null);
    const userBgColor = useColorModeValue(lightTheme.colors.lightGray, lightTheme.colors.lightGray);
    const claudeBgColor = useColorModeValue(lightTheme.colors.lightGray, "#2e93ea");
    const claudeColor = useColorModeValue("#000000", "#E2E8F0");
    const currentChatInputGeneration = useSelector(state => state.settings.currentChatInputGeneration);

    const { isTypingGeneration, setIsTypingGeneration } = useAuth();
    const {isThinkingGeneration, setIsThinkingGeneration} = useAuth();
    const generations = useSelector(state => state.documents.savedGenerations);
    const currentMessagesGeneration = generations.find(doc => doc.id === theDocumentGeneration.id).messages;
    const [isInputFocused, setIsInputFocused] = useState(false);

    const isAskVisibleGeneration = useSelector(state => state.settings.isAskVisibleGeneration);
    const isFollowUpVisibleGeneration = useSelector(state => state.settings.isFollowUpVisibleGeneration);

    const dispatch = useDispatch();
    const textareaRef = useRef(null);
    const { isOpen: isOpenSignUpScreen1, onOpen: onOpenSignUpScreen1, onClose: onCloseSignUpScreen1 } = useDisclosure();
    const { isOpen: isOpenSignInScreen1, onOpen: onOpenSignInScreen1, onClose: onCloseSignInScreen1 } = useDisclosure();
    const { isOpen: isOpenGeneratePromptScreen2, onOpen: onOpenGeneratePromptScreen2, onClose: onCloseGeneratePromptScreen2 } = useDisclosure();
    const toast = useToast();
    const [shouldReferenceSources, setShouldReferenceSources] = React.useState('true');
    const [sliderValue, setSliderValue] = React.useState(1000);
    const { isOpen: isOpenPricingScreen, onOpen: onOpenPricingScreen, onClose: onClosePricingScreen } = useDisclosure();

    const [filteredOptions, setFilteredOptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const pdfNames = generations.find(doc => doc.id === theDocumentGeneration.id).files.filter(file => file.isActive).map(file => file.name);
    const dropdownRef = useRef(null);
    const { serverIPs, setServerIPs, isDev } = useServerIP();
    // const [fixOCRLoading, setFixOCRLoading] = useState(false);
    //
    // const [selectedModel, setSelectedModel] = useState("default");
    const [pollKey, setPollKey] = useState(null);
    const [pollKeyChat, setPollKeyChat] = useState(null);
    const [thePrompt, setThePrompt] = useState("");
    const [theClaudeGenerationID, setTheClaudeGenerationID] = useState("");
    const [theUserGenerationID, setTheUserGenerationID] = useState("");
    const auth = useAuth();

    const handleMessageCreation = (type, question, wordCount, shouldReferenceSources) => {
        const userIDHere = uuidv4();
        const claudeID = uuidv4();
        // socketGeneration.off('receive_message');
        const userMessage = {
            id: userIDHere,
            type: type,
            user: 'User',
            question: question,
            // word_count: wordCount,
            // should_reference_sources: shouldReferenceSources,
        };
        const claudeMessage = {
            id: claudeID,
            type: type,
            user: 'Gemini',
            question: question,
            // word_count: wordCount,
            // should_reference_sources: shouldReferenceSources,
            response: ""
        };
        dispatch(addMessageInDocumentGeneration({ messageToAdd: userMessage, documentID: theDocumentGeneration.id }));
        dispatch(addMessageInDocumentGeneration({ messageToAdd: claudeMessage, documentID: theDocumentGeneration.id }));
        return { userGenerationID: userIDHere, claudeGenerationID: claudeID };
    }

    // startGeneration(prompt, sliderValue, shouldReferenceSources);
    const modifiedHandleNewMessage = () => {
        if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isChatExceeded") === "true") {
            toast({
                title: t("(Free Plan) Chat Limit Exceeded!"),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            dispatch(setIsPricingModalOpen(true));
            dispatch(setCurrentChatInputGeneration(''));
            if (textareaRef && textareaRef.current) {
                textareaRef.current.style.height = '3.5rem';
            }
            return;
        }

        if (currentMessagesGeneration && currentMessagesGeneration.length >= 3 && localStorage.getItem("userID") === null) {
            toast({
                title: t("You've reached your generation limit in guest mode!"),
                description: t("Please sign up to continue creating writing."),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
            dispatch(setCurrentChatInputGeneration(''));
            if (textareaRef && textareaRef.current) {
                textareaRef.current.style.height = '3.5rem';
            }
            return;
        }

        if (generations.find(doc => doc.id === theDocumentGeneration.id).files.length === 0) {
            toast({
                title: t("Please upload 1 or more sources!"),
                status: "error",
                duration: 7000,
                isClosable: true,
                position: "top",
            });
            // dispatch(setCurrentChatInputGeneration(''));
            if (textareaRef && textareaRef.current) {
                textareaRef.current.style.height = '3.5rem';
            }
            return;
        }

        const chatInput = currentChatInputGeneration;
        dispatch(setCurrentChatInputGeneration(''));

        const shouldReferenceSourcesBoolean = shouldReferenceSources === 'true';

        startGeneration(chatInput, 999, shouldReferenceSourcesBoolean);
        dispatch(setCurrentGenerationWordCount(sliderValue));

        dispatch(setCurrentChatInputGeneration(''));
        if (textareaRef && textareaRef.current) {
            textareaRef.current.style.height = '3.5rem';
        }
    };

    const handleKeyDown = (e) => {
        if (showDropdown) {
            if (e.key === "ArrowDown") {
                e.preventDefault();
                setSelectedIndex((prev) => Math.min(prev + 1, filteredOptions.length - 1));
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                setSelectedIndex((prev) => Math.max(prev - 1, 0));
            } else if (e.key === "Enter" && selectedIndex >= 0) {
                e.preventDefault();
                insertMention(filteredOptions[selectedIndex]);
            } else if (e.key === "Escape") {
                setShowDropdown(false);
            }
        } else {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                if (currentChatInputGeneration !== "" && !isTypingGeneration && !isThinkingGeneration) {
                    modifiedHandleNewMessage();
                }
            }
        }
    };

    const handleInput = (e) => {
        const value = e.target.value;
        dispatch(setCurrentChatInputGeneration(value)); // Immediately update the state with the current value

        const cursorPosition = e.target.selectionStart; // Get the cursor's position
        const textBeforeCursor = value.slice(0, cursorPosition); // Text before the cursor

        const lastAtIndex = textBeforeCursor.lastIndexOf("@"); // Find the last '@' before the cursor
        if (lastAtIndex !== -1) {
            const query = textBeforeCursor.slice(lastAtIndex + 1).toLowerCase(); // Extract query after '@'
            const filtered = pdfNames.filter((name) =>
                name.toLowerCase().startsWith(query)
            );
            setFilteredOptions(filtered);
            setShowDropdown(filtered.length > 0);
            setSelectedIndex(0); // Always select the first item by default
        } else {
            setShowDropdown(false); // Close dropdown if '@' is not detected
        }
    };

    const insertMention = (mention) => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const cursorPosition = textarea.selectionStart;
        const textBeforeCursor = currentChatInputGeneration.slice(0, cursorPosition);
        const textAfterCursor = currentChatInputGeneration.slice(cursorPosition);

        const lastAtIndex = textBeforeCursor.lastIndexOf("@");
        const newText =
            textBeforeCursor.slice(0, lastAtIndex) + `@${mention} ` + textAfterCursor;

        // Update the textarea value
        dispatch(setCurrentChatInputGeneration(newText));

        // Calculate the new cursor position (right after the inserted mention)
        const newCursorPosition = lastAtIndex + mention.length + 2; // +2 accounts for "@" and the space after the mention

        // Set the cursor position
        setTimeout(() => {
            textarea.setSelectionRange(newCursorPosition, newCursorPosition);
            textarea.focus(); // Refocus the textarea to ensure seamless typing
        }, 0);

        setShowDropdown(false);
    };


    const handleOptionClick = (option) => {
        insertMention(option);
        textareaRef.current.focus();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        const scrollMessageIntoView = () => {
            if (lastMessageRef.current) {
                // console.log('Height of last message:', lastMessageRef.current.offsetHeight);
                if (lastMessageRef.current.offsetHeight < 500) {
                    lastMessageRef.current.scrollIntoView({ behavior: 'instant', block: 'end' });
                }
            }
        };
        scrollMessageIntoView();

    }, [currentMessagesGeneration]);

    useEffect(() => {
        const scrollMessageIntoView = () => {
            if (lastMessageRef.current) {
                lastMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        };
        scrollMessageIntoView();

    }, []);

    const chatContainerRef = useRef(null);

    const placeholders = [t("Enter your prompt here..."),
        t("Shift + Enter to add a new line")];
    const [currentPlaceholder, setCurrentPlaceholder] = useState(placeholders[0]);
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(true); // State to manage fade in and out

    useEffect(() => {
        const intervalId = setInterval(() => {
            setFade(false); // Fade out the current placeholder

            setTimeout(() => {
                // After fade out, change the placeholder and fade it in
                setIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
                setCurrentPlaceholder(placeholders[index]);
                setFade(true);
            }, 750); // Half the interval time to allow for fade in and fade out
        }, 1500);

        return () => clearInterval(intervalId);
    }, [index]);

    //isGeneratePDFVisible: false,
    //currentGeneratePDF: "",
    //currentGeneratePDFPage: 1,
    const isGeneratePDFVisible = useSelector(state => state.settings.isGeneratePDFVisible);
    const onCitationClick = (filename, page) => {
        console.log("Filename", filename)
        console.log("Page", page)

        // based on the filename, find the corresponding file in the generation
        const file = generations.find(doc => doc.id === theDocumentGeneration.id).files.find(file => file.name === filename);
        if (file) {
            //console.log("FILE FOUND", file);
            console.log("isGeneratePDFVisible", isGeneratePDFVisible)
            if (isGeneratePDFVisible) {
                // console.log("Here")
                dispatch(setIsGeneratePDFVisible(false));
                dispatch(setCurrentGeneratePDFPage(page));
                dispatch(setCurrentGeneratePDF(file.url))
                dispatch(setIsGeneratePDFVisible(true))
                // console.log("pdf ref here 1")
                // console.log("pdfRef", pdfRef)
                if (pdfRef && pdfRef.jumpToPage) {
                    // console.log("pdf ref here 2")
                    setTimeout(() => {
                        pdfRef.jumpToPage(page);
                    }, 100);
                }
            } else {
                // console.log("Here 22")
                dispatch(setCurrentGeneratePDFPage(page));
                dispatch(setCurrentGeneratePDF(file.url))
                dispatch(setIsGeneratePDFVisible(true))
                // if (pdfRef && pdfRef.jumpToPage) {
                //     setTimeout(() => {
                //         pdfRef.jumpToPage(page);
                //     }, 100);
                // }
            }
        }
    };

    const memoizedMessages = useMemo(() => {
        return currentMessagesGeneration.slice(-40).map((message, index, slicedArray) => {
            // console.log("MESSAGE INNER PEACE", message);
            const isLastMessage = index === slicedArray.length - 1;
            return {
                ...message,
                isLastMessage
            };
        });
    }, [currentMessagesGeneration]);

    const dummyData = useMemo(() => {
        const out = {}
        for (let i = 1; i <= 1500; i++) {
            if (i === 3) {
                out[`JPM_NVIDIA_Report.pdf`] = `This is a dummy answer for document ${i}. It may be quite long—so you can click “Show more” to expand and “Show less” to collapse.`
            }
            // if i is even
            else if (i % 2 === 0) {
                out[`document_${i}.pdf`] = `This is a dummy answer for document ${i}. It may be quite long—so you can click “Show more” to expand and “Show less” to collapse.`
            } else {
                out[`document_${i}.pdf`] = `This is a dummy answer for document ${i}. It may be quite long—so you can click
                 “Show more” to expand and “Show less” to collapse. Show more” to expand and “Show less” to collapse. 
                 Show more” to expand and “Show less” to collapse. Show more” to expand and “Show less” to collapse.
                 Show more” to expand and “Show less” to collapse. Show more” to expand and “Show less” to collapse.
                 Show more” to expand and “Show less” to collapse. Show more” to expand and “Show less” to collapse.
                 Show more” to expand and “Show less” to collapse. Show more” to expand and “Show less” to collapse.
                 Show more” to expand and “Show less” to collapse. Show more” to expand and “Show less” to collapse.
                 Show more” to expand and “Show less” to collapse. Show more” to expand and “Show less” to collapse.
                 Show more” to expand and “Show less” to collapse. Show more” to expand and “Show less” to collapse.`
            }
        }
        return out
    }, [])

    const [bigQueryReady, setBigQueryReady] = useState(false);

    useEffect(() => {
        const startBigQuerySession = async () => {
            // setFixOCRLoading(true);
            // console.log("fix_ocr_clicked")
            // console.log("Is_Gibbersih", theDocument.isGibberish);
            // const thegibber = theDocument.isGibberish ? "gibberish" : null;
            // console.log("thegibber", thegibber !== null ? thegibber.toString() : null);
            try {
                const response = await axios.post(serverIPs.SERVER_IP + '/p36b/start_big_query_session', {
                    socketio_stream_room: socketIDGeneration,
                });
                console.log("response from /p36b/start_big_query_session", response)
                if (response.data.status === 200) {
                    // first find the messageID of the most recent message
                    // const messageID = currentMessages[currentMessages.length - 1].id;
                    // console.log("message id in FixOCR function", messageID);
                    if (response.data.message.start_session_initiated) {
                        const key = response.data.message.progress_key;
                        setPollKey(key);
                    }
                    // localStorage.setItem("fixOCRMessageID", messageID);
                    // setFixOCRLoading(false);
                    // dispatch(updateMessageInDocument({ messageID: messageID, type: "fix_ocr", user: "Claude", selection_text: "",
                    //     question: "Fixing OCR Question 1", response: "Booting up the magic", documentID: theDocument.id }));
                }
            } catch (error) {
                console.log("/p36b/start_big_query_session error", error);
                // setFixOCRLoading(false);
                toast({
                    title: t('Oops, something went wrong. Please refresh the page and try again.'),
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                })
            }
        };
        startBigQuerySession();

    }, []);

    const startGeneration = async (prompt, sliderValue, shouldReferenceSources) => {
        const { userGenerationID, claudeGenerationID } = handleMessageCreation("general_multidoc", prompt, sliderValue, shouldReferenceSources);
        setTheUserGenerationID(userGenerationID);
        setTheClaudeGenerationID(claudeGenerationID);
        const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111";

        dispatch(resetCurrentChatResponseGeneration());
        dispatch(setCurrentChatUserIDGeneration(userGenerationID));
        dispatch(setCurrentChatClaudeIDGeneration(claudeGenerationID));
        dispatch(setCurrentChatQuestionGeneration(prompt));
        dispatch(setCurrentChatTypeGeneration("general_multidoc"));
        setIsThinkingGeneration(true);
        setIsTypingGeneration(false);

        setThePrompt(prompt);
        try {
            console.log("SOCKETIDGENERATION", socketIDGeneration);
            const response = await axios.post(serverIPs.SERVER_IP + '/p36b/make_big_query', {
                socketio_stream_room: socketIDGeneration,
                query: prompt,
            });
            console.log("response from /p36b/make_big_query", response)
            if (response.data.status === 200) {
                // first find the messageID of the most recent message
                // const messageID = currentMessages[currentMessages.length - 1].id;
                // console.log("message id in FixOCR function", messageID);
                if (response.data.message.query_initiated) {
                    const key = response.data.message.progress_key;
                    setPollKeyChat(key);
                }
                // localStorage.setItem("fixOCRMessageID", messageID);
                // setFixOCRLoading(false);
                // dispatch(updateMessageInDocument({ messageID: messageID, type: "fix_ocr", user: "Claude", selection_text: "",
                //     question: "Fixing OCR Question 1", response: "Booting up the magic", documentID: theDocument.id }));
            }
        } catch (error) {
            console.log("/p36b/make_big_query error", error);
            // setFixOCRLoading(false);
            toast({
                title: t('Oops, something went wrong. Please refresh the page and try again.'),
                status: "error",
                duration: 5000,
                isClosable: true,
            })
        }
    };

    useEffect(() => {
        if (!pollKey) return;

        const interval = setInterval(async () => {
            try {
                const res = await axios.post(
                    `${serverIPs.SERVER_IP}/general_progress`,
                    { key: pollKey }
                );
                console.log("RESPONE from /polling general_progress", res);
                const prog = res.data.message;
                if (prog.includes("Session created")) {
                    // const messageID = localStorage.getItem("fixOCRMessageID");
                    // dispatch(updateMessageInDocument({
                    //     messageID,
                    //     type: "fix_ocr",
                    //     user: "Claude",
                    //     selection_text: "",
                    //     question: "Fixing OCR Question 1",
                    //     response: "Finished!",
                    //     documentID: theDocument.id
                    // }));
                    clearInterval(interval);
                    setBigQueryReady(true);
                }
            } catch (err) {
                console.error("Polling general_progress error", err);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [pollKey]);

    useEffect(() => {
        if (!pollKeyChat) return;
        const interval = setInterval(async () => {
            try {
                console.log("POLL KEY CHAT", pollKeyChat)
                const res = await axios.post(
                    `${serverIPs.SERVER_IP}/general_progress`,
                    { key: pollKeyChat }
                );
                console.log("RESPONE from /polling general_progress CHAT", res);
                const prog = res.data.message;
                if (prog.status.includes("completed")) {
                    // 1) build an object mapping each filename → its result text
                    const resultMap = {};
                    prog.summary.results.forEach(({ metadata: { filename }, result }) => {
                        resultMap[filename] = result;
                    });

                    // 2) pull out the honeybear summary into its own object
                    const summaryMap = {
                        honeybear_summary_of_responses: prog.honeybear_summary_of_responses
                    };

                    console.log("resultMap:", resultMap);
                    console.log("summaryMap:", summaryMap);

                    setIsThinkingGeneration(false);
                    setIsTypingGeneration(false);
                    dispatch(updateMessageInDocumentGeneration2({ messageID: theClaudeGenerationID, type: "general_multidoc",
                        user: 'Gemini', question: thePrompt, response: summaryMap.honeybear_summary_of_responses,
                        tableResponse: resultMap ,documentID: theDocumentGeneration.id }));
                    console.log("Finished THE UPDATE AFTER MESSAGE BIG QUERY")
                    clearInterval(interval);
                }
            } catch (err) {
                console.error("Polling general_progress error", err);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [pollKeyChat]);

    const [current, setCurrent] = useState(0);
    const [total, setTotal] = useState(0);
    const [documentJustFinished, setDocumentJustFinished] = useState("");

    useEffect(() => {
        // socketio.emit('advanced_OCR_repair_with_VLM', {'progress': "Downloading PDF we had trouble parsing..."}, room=socketio_stream_room)
        // socketio.emit('advanced_OCR_repair_with_VLM', {'progress': f"Running VLM query on page {page_number}..."}, room=socketio_stream_room)
        // socketio.emit('advanced_OCR_repair_with_VLM', {'progress': f"Finished VLM query on page {page_number}"}, room=socketio_stream_room)
        // socketio.emit('advanced_OCR_repair_with_VLM', {'progress': "Finished uploading augmented PDF to s3..."}, room=socketio_stream_room)
        // console.log("LOGGING THE SOCKET", socketGeneration);
        socketGeneration.on('query_independent_on_n_docs', function (data) {
            console.log("data from query_independent_on_n_docs", data);

            // this is the current document that is being processed
            const currentDocument = data.progress.current_progress;

            // this is the total number of documents being processed
            const totalDocuments = data.progress.total_documents;

            // this is the document name that was just finished
            const documentJustFinished = data.progress.document_just_finished;

            setCurrent(currentDocument);
            setTotal(totalDocuments);
            setDocumentJustFinished(documentJustFinished);

        });
        return () => {
            console.log("Socket disconnecting", socketGeneration)
            socketGeneration.disconnect();
        }
    }, []);

    return (
        <Box display="flex" flexDirection="column" justifyContent="space-between" p={0} boxShadow="sm" borderRadius="md"
             border="0px" borderColor="gray.300" h="92.5vh" maxW="100%">
            <Box h={currentMessagesGeneration.length > 0 ? '90.5%': '100%'} overflowY="auto" className={currentMessagesGeneration.length > 7 ? "delayed-survey" : "normal"}
                 ref={chatContainerRef}>
                <Flex justifyContent={'flex-start'} flexDirection={'column'} height={'100%'}>
                    {currentMessagesGeneration.length > 0 ?
                        memoizedMessages.map(({ isLastMessage, ...message }, index) => (
                            <MessageBubbleMultidoc2
                                key={message.id}
                                dummyData={dummyData}
                                sessionToken={sessionTokenGeneration}
                                socketID={socketIDGeneration}
                                message={message}
                                isLastMessage={isLastMessage}
                                userBgColor={userBgColor}
                                claudeBgColor={claudeBgColor}
                                claudeColor={claudeColor}
                                lastMessageRef={lastMessageRef}
                                onCitationClick={onCitationClick}
                                socketGeneration={socketGeneration}
                            />
                        )) :

                        <Flex justifyContent={'flex-start'} flexDirection={'column'} height={"100vh"} alignItems={"center"}>
                            {bigQueryReady ?
                                <VStack spacing={12} mt={5} borderWidth={0} width={'70%'} height={'100%'} align={'center'}>
                                    <VStack align={'center'} width={'100%'} spacing={3}>
                                        <Text fontSize={'2xl'} fontWeight={'800'} >{t("Chat with Multiple PDFs")}</Text>
                                        <Text fontSize={16} fontWeight={'600'} color={'gray'}>{t("Upload your sources.")}</Text>
                                        <Text fontSize={16} fontWeight={'600'} color={'gray'}>{t("Ask a question, get a response citing your sources.")}</Text>
                                    </VStack>

                                    <Flex justifyContent={'flex-start'} flexDirection={'column'} height={"100vh"} alignItems={"center"} bg={'white'}>
                                        <VStack spacing={5} align="center" bg={'white'} width={'100%'} mt={'-1.5rem'}>
                                            <VStack spacing={4}>
                                                <HStack spacing={6}>
                                                    <Text fontSize="xl" fontWeight="bold">
                                                        {t("Examples")}
                                                    </Text>
                                                </HStack>
                                                <VStack spacing={3} align={'center'}>
                                                    {[t("Summarize each document in great detail"),
                                                        t("Where and in which document can I find info about ____"),
                                                        t("Create a comprehensive study guide based on the uploaded materials"),
                                                        t("Draft a discussion post that reacts to & analyzes the arguments of each document")].map((example, index) => (
                                                        <Button justifyContent="flex-start" variant="ghost" key={index}
                                                                width={['70%','75%', '90%', '95%', '111%']} py={'1.5rem'}
                                                                borderWidth={1} borderColor={lightTheme.colors.gray}
                                                                _hover={{ bg: lightTheme.colors.lightGray }} borderRadius={'10px'}
                                                                onClick={() => {
                                                                    dispatch(setCurrentChatInputGeneration(example));
                                                                    textareaRef.current.focus();
                                                                }}>
                                                            <Flex justifyContent="space-between" width="100%" alignItems="center">
                                                                <Text fontSize={"14px"} fontWeight={'600'} color={'blue'} mr={2}
                                                                      noOfLines={[2, 3, 4]} style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
                                                                    "{example}"
                                                                </Text>
                                                                <Icon as={AiOutlineArrowRight} color={'blue'} fontWeight={'bold'}/>
                                                            </Flex>
                                                        </Button>
                                                    ))}
                                                </VStack>
                                            </VStack>
                                            <VStack spacing={4}>
                                                <HStack spacing={6}>
                                                    <Text fontSize="xl" fontWeight="bold">{t("Tips")}</Text>
                                                </HStack>
                                                <VStack align="center" width={'83%'} spacing={3} borderWidth={1} borderColor={lightTheme.colors.gray}
                                                        borderRadius={'10px'} p={'1.5rem'}>
                                                    <List spacing={5} textAlign="start">
                                                        <ListItem key={1}>
                                                            <Flex align="start">
                                                                <ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={4} />
                                                                <Text fontSize={"14px"} fontWeight={'500'}>{t("Provide clear, detailed instructions for best results.")}</Text>
                                                            </Flex>
                                                        </ListItem>
                                                        <ListItem key={2}>
                                                            <Flex align="start">
                                                                <ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={4} />
                                                                <Text fontSize={"14px"} fontWeight={'500'}>{t("Provide enough context in your question so the AI knows what you want.")}</Text>
                                                            </Flex>
                                                        </ListItem>
                                                        <ListItem key={2}>
                                                            <Flex align="start">
                                                                <ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={4} />
                                                                <Text fontSize={"14px"} fontWeight={'500'}>{t("Click \"View Sources\" above the PDF viewer to toggle between different sources")}</Text>
                                                            </Flex>
                                                        </ListItem>
                                                    </List>
                                                </VStack>
                                            </VStack>
                                        </VStack>
                                    </Flex>
                                </VStack> :
                                <Box bg={'transparent'} align={'center'}>
                                    {/*<Text fontSize={"md"} mt={1} mb={1.5}>{t("Please don't refresh the page.")}</Text>*/}
                                    <Lottie
                                        animationData={lottieFixOCR}
                                        loop={true}
                                        autoplay={true}
                                        style={{ width: '80%', height: '80%', backgroundColor:'transparent',
                                            marginTop: '2rem', marginBottom:'1rem'}}
                                    />
                                    <Text fontSize={20} color={'black'} mt={0} fontWeight="500">
                                        Getting ready...
                                    </Text>
                                </Box>
                            }
                        </Flex>
                    }
                </Flex>
            </Box>
            {currentMessagesGeneration.length >= 0 ?
                <Box position="relative" mt="auto">
                    <form onSubmit={modifiedHandleNewMessage} style={{backgroundColor: 'white'}}>
                        <HStack spacing={0} width={'100%'} pt={1} bg='white' justifyContent={'flex-start'} alignItems={'flex-start'}>

                            {/* upload file icon here */}
                            <VStack>
                                <Button
                                    as="label"
                                    variant="outline"
                                    border="1px"
                                    borderColor="gray.300"
                                    color="black"
                                    leftIcon={<Box fontSize="1.25rem">
                                        <AiOutlineUpload />
                                    </Box>}
                                    size="sm"
                                    cursor="pointer"
                                    _hover={{ backgroundColor: 'gray.100' }}
                                    _active={{ backgroundColor: 'gray.200' }}
                                    marginLeft={'0.5rem'}
                                    onClick={() => {
                                        onOpenGeneratePromptScreen2()
                                        dispatch(setIsUploadSourcesModalOpen(true))
                                    }}
                                >
                                    Upload Sources
                                </Button>
                                <Text fontSize={'xs'} color={'gray'} fontWeight={'500'}>
                                    {generations.find(doc => doc.id === theDocumentGeneration.id).files.filter(file => file.isActive).length} sources active
                                </Text>
                            </VStack>

                            <VStack align="center" h="auto" marginLeft={'0.5rem'} marginBottom={'0.4rem'}
                                    borderWidth={'1px'} marginRight={'1.4rem'}
                                    borderColor={isInputFocused ? 'blue' : lightTheme.colors.darkGray}
                                    borderRadius={'md'} flexGrow={1}>
                                <HStack width={'100%'} position={'relative'} spacing={0} align={"flex-end"}
                                        justifyContent={'space-between'}>
                                    <Textarea
                                        name="message-input"
                                        ref={textareaRef}
                                        placeholder={generations.find(doc => doc.id === theDocumentGeneration.id).files.length !== 0 ?
                                            currentPlaceholder : "Upload a source to get started"}
                                        onKeyDown={handleKeyDown}
                                        value={currentChatInputGeneration}
                                        style={{
                                            border: 'none',
                                            borderRight: 'none',
                                            borderRightColor: "white",
                                            marginRight: 0,
                                            borderTopWidth: isAskVisibleGeneration || isFollowUpVisibleGeneration ? '0px' : '1px',
                                            borderTopLeftRadius: isAskVisibleGeneration || isFollowUpVisibleGeneration ? '0px' : '10px',
                                            borderTopRightRadius: isAskVisibleGeneration || isFollowUpVisibleGeneration ? '0px' : '10px'
                                        }}
                                        _focus={{boxShadow: 'none', outline: 'none'}}
                                        onChange={handleInput}
                                        minH={'3.5rem'}
                                        onFocus={() => setIsInputFocused(true)}
                                        onBlur={() => setIsInputFocused(false)}
                                        overflowY="auto"  // Allow vertical scrollbar
                                        maxH="29rem"
                                        resize="none"  // Disable manual resizing
                                        onInput={(e) => {  // Auto-expand as text overflows
                                            e.currentTarget.style.height = 'auto';
                                            e.currentTarget.style.height = (e.currentTarget.scrollHeight) + 'px';
                                        }}
                                        required
                                        width={'92%'}
                                    />
                                    <Box width={'2.85rem'}>
                                        <Button
                                            aria-label="Send message"
                                            type="submit"
                                            isDisabled={currentChatInputGeneration === ""}
                                            position="relative"
                                            cursor="pointer"
                                            _hover={{backgroundColor: 'white'}}
                                            borderRadius="md"
                                            backgroundColor={"white"}
                                            transition="background 0.2s"
                                            height={'2.5rem'}
                                            width={'100%'}
                                            size={'32'}
                                            onClick={() => {
                                                modifiedHandleNewMessage();
                                            }}
                                        >
                                            <AiOutlineSend style={{fontSize: '22px'}}/>
                                        </Button>
                                    </Box>
                                </HStack>
                                {showDropdown && (
                                    <List
                                        ref={dropdownRef}
                                        position="absolute"
                                        bottom="4rem"
                                        left="11rem"
                                        bg="white"
                                        borderColor={'lightgray'} borderWidth={0.25}
                                        shadow={`1.5px 1.8px 0px lightgray`}
                                        borderRadius="md"
                                        maxH="17rem"
                                        overflowY="auto"
                                        zIndex={1000}
                                        width="70%"
                                    >
                                        {filteredOptions.map((option, index) => (
                                            <ListItem
                                                key={option}
                                                bg={selectedIndex === index ? "blue.600" : "white"}
                                                color={selectedIndex === index ? "white" : "black"}
                                                px={4}
                                                py={3}
                                                fontSize={15}
                                                fontWeight={500}
                                                cursor="pointer"
                                                onClick={() => handleOptionClick(option)}
                                                onMouseEnter={() => setSelectedIndex(index)}
                                            >
                                                {option}
                                            </ListItem>
                                        ))}
                                    </List>
                                )}
                            </VStack>
                        </HStack>
                    </form>
                </Box>
                : null}
            {currentMessagesGeneration.length !== 0 ?
                <Box justifyContent={"flex-end"} display={"flex"} mr={'1.4rem'} mb={2}>
                    <Text fontSize={"xs"} color={"gray"}>{t("Shift + Enter to add a new line")}</Text>
                </Box>
                : null}
            <SignUpScreen1 isOpenSignUpScreen1={isOpenSignUpScreen1} onCloseSignUpScreen1={onCloseSignUpScreen1}
                           onOpenSignInScreen1={onOpenSignInScreen1}/>
            <SignInScreen1 isOpenSignInScreen1={isOpenSignInScreen1} onCloseSignInScreen1={onCloseSignInScreen1}
                           onOpenSignUpScreen1={onOpenSignUpScreen1}/>
            <PricingScreen isOpenPricingScreen={isOpenPricingScreen}
                           onClosePricingScreen={onClosePricingScreen}
                           onOpenPricingScreen={onOpenPricingScreen}/>
            <GeneratePromptScreen2 isOpenGeneratePromptScreen2={isOpenGeneratePromptScreen2}
                                   onCloseGeneratePromptScreen2={onCloseGeneratePromptScreen2}
                                   generation={theDocumentGeneration} sessionTokenGeneration={sessionTokenGeneration}/>
        </Box>
    );
};
